import { InitialFiltersState } from '../../reducers/initial-filter/InitialFiltersReducer';
import { InitialFiltersTypes } from '../Type';

export const updateInitialFilters = (payload: InitialFiltersState) => {
  return (dispatch: any) => {
    dispatch({
      type: InitialFiltersTypes.InitialFiltersUpdate,
      payload,
    });
  };
};
